export default "__VITE_ASSET__DwDWf5yh__"